
import {map} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output, Directive } from '@angular/core';
import { JsonPatchOperation } from '@oa/shared-core';
import { format } from 'date-fns';
import { Observable } from 'rxjs';

import { ListingSeason } from '../models';
import { HttpHelperService } from '@oa/shared-core';

@Directive()
@Injectable()
export class SeasonsService {
  @Output() update: EventEmitter<ListingSeason> = new EventEmitter();
  @Output() delete: EventEmitter<ListingSeason> = new EventEmitter();

  constructor(private http: HttpClient, private httpHelper: HttpHelperService) {}

  /**
   * Patches a single value for a ListingSeason
   * @param id
   * @param path
   * @param value
   */
  public patchValue(id: number, path: string, value: any) {
    let patchOperation = { path, value, op: 'replace' } as JsonPatchOperation;

    return this.httpHelper.patch(`seasons/${id}`, [patchOperation]);
  }

  /**
   * Patches multiple values for a ListingSeason in a single patch operation
   * @param id
   * @param patchDocument
   */
  public patchValues(id: number, patchDocument: JsonPatchOperation[]) {
    return this.httpHelper.patch(`seasons/${id}`, patchDocument);
  }

  assign(listingId: number, seasonId: number, dates: Date[]) {
    const formattedDates = dates.map(d => format(d, 'yyyy-MM-dd'));
    return this.http.post(`seasons/assign/${listingId}/${seasonId}`, formattedDates);
  }

  getSeasons(listingId: number): Observable<ListingSeason[]> {
    return this.http.get<ListingSeason[]>('seasons/' + listingId);
  }
  seasonUpdate(season: ListingSeason) {
    return this.http.patch<ListingSeason>('seasons/update', season).pipe(map(() => this.update.emit(season)));
  }
  seasonRemove(season: ListingSeason) {
    console.log('Deleting' + season.id);
    return this.http.delete('seasons/' + season.id).pipe(map(() => this.delete.emit(season)));
  }
  seasonAdd(season: ListingSeason) {
    console.log('Submitting', season);

    return this.http.post<ListingSeason>('seasons/add', season).pipe(map(() => this.update.emit(season)));
  }
}
function seasonUrl(listingOption: ListingSeason): string {
  return `seasons/`;
}
export type ListingSeasonPatch<K extends string & keyof ListingSeason> = { path: K; value: ListingSeason[K]; op: 'replace' };
